export * from "./fetch";
import { useMutation } from "../../utils/use-mutation";
import { onfidoSdkTokenCreate } from "./fetch";
export const useOnfidoSdkTokenCreate = (params) => {
    return useMutation(onfidoSdkTokenCreate, params);
};
